export const GRAMMAR_LESSON_DRILL_LIMITS = {
  min: 6,
  max: 8,
} as const;
